import { z } from 'zod'
import { HexNumber } from '@lukso/controllerapps-sharedlogic-primitives'

import { ReadyEncodedCrossDeployCalldata } from '../../../cross-chain-deployment/ReadyEncodedCrossDeployCalldata'

export const ReadyEncodedCrossDeployCalldataSchema = z.string()

type ReadyEncodedCrossDeployCalldataReportText = z.infer<
  typeof ReadyEncodedCrossDeployCalldataSchema
>

export function mapDomainToReportText(
  calldata: ReadyEncodedCrossDeployCalldata
): ReadyEncodedCrossDeployCalldataReportText {
  return calldata.getValue().getValue()
}

export function mapReportTextToDomain(
  reportText: ReadyEncodedCrossDeployCalldataReportText
): ReadyEncodedCrossDeployCalldata {
  return ReadyEncodedCrossDeployCalldata.create(
    HexNumber.create({ hexNumberValue: reportText })
  )
}
